import {
	SendPhone2FAPayload,
	SendPhone2FAResponse,
	sendPhone2FA,
} from "@/api/phone-auth";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";

export default function useSendPhoneVerificationCode(
	options?: MutationOptionsWithoutFn<SendPhone2FAResponse, SendPhone2FAPayload>,
) {
	return useMutation({
		mutationFn: (payload: SendPhone2FAPayload) => sendPhone2FA(payload),
		...options,
	});
}
